import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnboardingService } from '../onboarding.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MixpanelService } from 'src/app/shared/service/mix-panel.service';
import { MixpanelEvent } from 'src/app/shared/model/mix-panel-event.enum';
import { UserDetailsService } from 'src/app/core/services/user-details/user-details.service';
import { ZendeskService } from 'src/app/shared/service/zendesk.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {
  resend: boolean = false;
  verifyForm!: FormGroup;
  submitted = false;
  userId: any;
  timer: any = 30;
  showErrMsg: any = false;
  errorMessage: any;
  @ViewChild('progressDialog', { static: true }) secondDialog: TemplateRef<any>;

  constructor(private fb: FormBuilder, private dialog: MatDialog, private route: ActivatedRoute, private router: Router, private onboardingService: OnboardingService,private mixpanelService:MixpanelService,
    private userDetailsService: UserDetailsService,
    private zenDeskService:ZendeskService
    
  ) { }

  ngOnInit(): void {
    console.log(history.state)
    this.userId = history.state.userId
    if (!this.userId) {
      this.router.navigate(['/signup'])
    }
    this.verifyForm = this.fb.group({
      verificationCode: ['', Validators.compose([Validators.required])]
    });
    const interval = setInterval(() => {
      this.timer = this.timer - 1;
      if (this.timer <= 0) {
        clearInterval(interval)
        this.resend = true
      }
    }, 1000)
  }

  get verifyFormControl() {
    return this.verifyForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.verifyForm.dirty && this.verifyForm.valid) {
      this.dialog.open(this.secondDialog, { disableClose: true });
      //alert('Form Submitted succesfully!!!\n Check the values in browser console.');
      console.log(this.verifyForm.value);
      this.onboardingService.verifyUserSignUp(this.userId, this.verifyForm.value).subscribe((res) => {
        console.log(res)
        if (res.status == 200) {
          this.trackOnSignupCompleted(res.body.id);
          if (res.body) {
            if (!res.body.isOtpVerified) {
              this.dialog.closeAll()
              this.onboardingService.userDetails.isOtpVerified = true;
              this.router.navigate(['/verification'])
            } else if (!res.body.isSetupVisited) {
              this.dialog.closeAll()
              this.setZenDeskUserDetails(res.body.id);
              this.router.navigate([`userProfiles/${res.body.id}/setup/1`])
            } else {
              this.dialog.closeAll()
              this.setZenDeskUserDetails(res.body.id);
              window.location.href = "/";
            }
          } else {
            this.router.navigate(['/login'])

          }
          //need to configure setup pages
          //  window.location.href = `${environment.apiURL}/userProfiles/${this.userId}?home=true`;
        }
      }, err => {
        this.dialog.closeAll()
        console.log(err)
        if (err == 500) {
          this.errorMessage = "Invalid verification code";
          this.showErrMsg = true
        }
      })
    }

  }

  resendVerficationEmail() {
    this.timer = 30;
    this.resend = false;
    this.onboardingService.resendEmail(this.userId).subscribe((res) => {
      console.log(res)
      const interval = setInterval(() => {
        this.timer = this.timer - 1;
        if (this.timer <= 0) {
          clearInterval(interval)
          this.resend = true
        }
      }, 1000)
    }, err => {

    })
  }

  get verifyFormControlItem() {
    return this.verifyForm.controls;
  }
  trackOnSignupCompleted(userId:any){
    this.mixpanelService.alias(userId)
    this.mixpanelService.identifyUser(userId)
    this.mixpanelService.trackEvent({
          event:MixpanelEvent.BUTTON_CLICKED,
          properties:{
            title:"OTP_verified"
          }
        })
  }

    setZenDeskUserDetails(userId:string) {
    this.userDetailsService.getUserDetails(userId).subscribe({
      next:(res: any) => {
      let name =  res.firstName + " "+ res.lastName;
      let email = res.emailAddress;
      this.zenDeskService.setUserIdentity(userId,name,email);
    },
    error:(err)=>{
      console.log(err)}
    }
  )
  }
}